import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'batchErrors.title',
    defaultMessage: 'Errors',
    description: 'Title of the batch errors section',
  },
  feedback: {
    failedJobNotice: {
      id: 'batchErrors.feedback.failedJobNotice',
      defaultMessage: 'The batch has failed. Please contact Afosto to work out what went wrong.',
      description: 'Error message of the failed batch',
    },
  },
};

export default defineMessages(translations);
